import axiosConnectorInstance from "./AxiosConnector"
import { localStorageNames } from "../const"
import { router } from "../utils/APIUrls"

export const getCurrentUser = async () => {
  try {
    const response = await axiosConnectorInstance.get(router?.currentUser, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getUserImage = async (userEmail) => {
  try {
    const response = await axiosConnectorInstance.get(`${router?.userImage}?userId=${userEmail}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getTenants = async () => {
  try {
    const response = await axiosConnectorInstance.get(router?.tenants, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const switchTenant = async (tenantId) => {
  try {
    const response = await axiosConnectorInstance.put(`${router?.switchTenant}/${tenantId}`, "", {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getLocations = async () => {
  try {
    const response = await axiosConnectorInstance.get(router?.locations, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getSeatsByAreaId = async (areaId) => {
  try {
    const response = await axiosConnectorInstance.get(`${router?.areas}/${areaId}/Seats`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const updateSeatsByTenantIdLocationIdAndAreaId = async (tenantId, locationId, areaId, queryData) => {
  try {
    const response = await axiosConnectorInstance.put(`${router?.adminTenant}/${tenantId}/Locations/${locationId}/Areas/${areaId}/Seats`, queryData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(localStorageNames?.tokenName),
      },
    })

    return response?.data
  } catch (error) {
    return error?.response?.data
  }
}

export const getAreaMap = async (areaId) => {
  try {
    const res = await axiosConnectorInstance.get(`${router?.areas}/${areaId}/Map?rotateImage=false`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })

    return res.data
  } catch (error) {
    return error.response.data
  }
}

export const getAllMeetingRooms = async (requestPayload) => {
  try {
    const res = await axiosConnectorInstance.get(router?.location, {
      params: requestPayload,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })

    return res.data
  } catch (error) {
    return error.response.data
  }
}